export default function isEmpty(value){
    return (value === undefined || value === '' || value === null || value === []) 
}


// WEBPACK FOOTER //
// ./src/utils/functions/isEmpty.js